import { memo, useMemo } from 'react';
import cn from 'classnames';

import { BreadcrumbItem } from './BreadcrumbItem';
import styles from './Breadcrumb.module.scss';

export interface IBreadcrumbItemProps {
  name: string;
  onClick?: () => void;
}

interface IBreadcrumbProps {
  className?: string;
  items: IBreadcrumbItemProps[];
}

export const Breadcrumb = memo(({ className = '', items }: IBreadcrumbProps) => {
  const breadcrumbClassNames = useMemo(() => cn(styles.Breadcrumb, className), [className]);

  return (
    <ol className={breadcrumbClassNames}>
      {items.map(item => (
        <BreadcrumbItem key={item.name} name={item.name} onClick={item.onClick} />
      ))}
    </ol>
  );
});
